import React, { FC, useEffect, useMemo, useRef } from "react"
import {
    APIJobModel,
    JobStatus,
    JobVersionItem
} from "../../../../../../../../Models/API/JobModel"
import { relativeAndAbsoluteDateTime } from "../../../../../../../../Helpers/Functions/dateFormat"
import { CollapsibleSectionHeader } from "../../../../../../../Common/CollapsibleSectionHeader/CollapsibleSectionHeader"
import { Property } from "dash-styled"

interface JobDetailViewDetailsSection {
    isOpen: boolean
    job: APIJobModel
    versionsList: JobVersionItem[]
    onToggleOpen: () => void
}

/**
 * @deprecated
 */
export const JobDetailViewDetailsSection: FC<JobDetailViewDetailsSection> = ({
    isOpen,
    job,
    versionsList,
    onToggleOpen
}) => {
    const ref = useRef<HTMLDivElement>(null)
    const earliestVersion = useMemo(
        () => versionsList[versionsList.length - 1],
        [versionsList]
    )

    useEffect(() => {
        if (isOpen) {
            ref.current?.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start"
            })
        }
    }, [isOpen])

    const workerExists =
        job.workers !== null &&
        (job.workers.ais !== null ||
            job.workers.crowd === true ||
            job.workers.users !== null)

    return (
        <div
            ref={ref}
            className="text-rhino-700 text-sm"
            data-testid="job-detail-view-details"
        >
            <CollapsibleSectionHeader
                isOpen={isOpen}
                separator={true}
                onToggle={onToggleOpen}
            >
                Details
            </CollapsibleSectionHeader>
            {isOpen && (
                <dl className="pl-5 pt-4">
                    {workerExists && (
                        <Property name="Workers involved">
                            <ul>
                                {job.workers?.ais?.map(ai => (
                                    <li key={ai}>{ai} (AI model)</li>
                                ))}
                                {job.workers?.users?.map(user => (
                                    <li key={user}>{user} (Human worker)</li>
                                ))}
                                {job.workers?.crowd === true && (
                                    <li>super.AI workers</li>
                                )}
                            </ul>
                        </Property>
                    )}
                    {earliestVersion.created === null ? null : (
                        <Property
                            name={
                                versionsList.length > 1
                                    ? "Originally created "
                                    : "Created "
                            }
                        >
                            {relativeAndAbsoluteDateTime(
                                earliestVersion.created
                            )}
                        </Property>
                    )}
                    {job.status === JobStatus.COMPLETED ? (
                        <Property name="Completed">
                            {relativeAndAbsoluteDateTime(job.completed)}
                        </Property>
                    ) : null}
                </dl>
            )}
        </div>
    )
}
